import { safeDefine } from "@breuni-ui/safe-define";
import { CarouselNavigationPrev } from "@breuni-ui/carousel";

class RecoCarouselNaviPrev extends CarouselNavigationPrev {}
safeDefine("reco-carousel-navi-prev", RecoCarouselNaviPrev);
